<div class="card">
    <div class="card-header">
        <span class="material-icons">favorite</span>
        <h2 class="card-title">Favorites</h2>
    </div>
    <div class="card-body">
        <ul class="list-group list-group-flush user-favs-list">
            @for (favorite of favorites; track favorite.id) {
                <li class="list-group-item">
                    <span class="md-24" [class.material-icons]="!['collections', 'reports'].includes(favorite.resource)" [class.material-icons-outlined]="['collections', 'reports'].includes(favorite.resource)" [routerLink]="['/' + favorite.resource, favorite.i]">{{icon(favorite.resource)}}</span>
                    <div class="text-truncate" [routerLink]="['/' + favorite.resource, favorite.i]">
                        <h5>{{favorite.label}}</h5>
                        <p class="subtitle">{{favorite.resource}}</p>
                    </div>
                    <span class="dripicons-trash text-danger clickable" (click)="remove($event, $index)"></span>
                </li>
            }
            @empty {
                <li class="list-group-item">No favorites found for this user yet.</li>
            }
        </ul>
    </div>
</div>